import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/AxiosInstance.jsx';
import { getCurrentUser } from '../utils/Sessions';
import { handlePromise } from '../utils';

const useUser = () => {
  const me = getCurrentUser();
  return useQuery({
    queryKey: ['user', me.user_id],
    queryFn: () => handlePromise(axiosInstance.get('/internal_api/user/me')),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};

export default useUser;
